<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
            aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edycja zamówienia</h5>
                        <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="form && isReady" class="container-fluid">
                            <div class="row">

                                <div class="col-md-5">
                                    <label for="dueDate">Ostateczny termin dostawy:</label>
                                    <div class="mb-4" style="max-width: 300px;">
                                        <ejs-datepicker id="projectFileProgressId" placeholder="Wybierz zakres dat"
                                            :value="form.dueDate" :format="dueDateFormat" :weekNumber="true"
                                            @change="changeDeliveryDate"></ejs-datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 mb-2">
                                    <Vueform :key="formKey">
                                        <TextElement name="comment" :default="form.comment" @change="changeComment"
                                            autocomplete="off" label="Komentarz do zamówienia" />
                                    </Vueform>
                                </div>
                            </div>

                            <div class="row mb-3">

                                <div class="col-md-4">
                                    <label>Forma płatności</label>
                                    <select class="form-select form-select-sm" v-model="form.payment_id">
                                        <option v-for="method in paymentMethods" :key="method.id" :value="method.id">
                                            {{ method.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label>Waluta globalna</label>

                                    <select
                                        class="form-select form-select-sm"
                                        v-model="globalCurrency"
                                        @change="applyGlobalCurrency">
                                        <option :value="null">Wybierz walutę</option>

                                        <option
                                            v-for="currency in currencys"
                                            :key="currency.id"
                                            :value="currency.name">
                                            {{ currency.name }}
                                        </option>
                                    </select>

                                    <div
                                        v-if="orderHasMultipleCurrencies"
                                        class="text-danger small mt-1">
                                        Uwaga! Zamówienie zawiera artykuły w różnych walutach.
                                        Ujednolić waluty przed zapisaniem zamówienia.
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Rabat globalny (%)</label>

                                    <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        v-model.number="globalRabate"
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        placeholder="Różne rabaty"
                                        @input="applyGlobalRabate">

                                    <div
                                        v-if="globalRabate === null"
                                        class="text-muted small mt-1">
                                        Artykuły mają różne rabaty.
                                        Wpisanie wartości ustawi rabat dla wszystkich pozycji.
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Ustalona kwota netto</label>
                                    <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        v-model.number="fixedNettoAmount"
                                        min="0"
                                        step="0.01"
                                        @input="applyFixedNettoAmount">
                                </div>

                                <div class="col-md-4">
                                    <label>Adres dostawy</label>
                                    <select
                                        class="form-select form-select-sm"
                                        v-model="form.order_where"
                                        @change="onOrderWhereChange">
                                        <option
                                            v-for="where in order_where_list"
                                            :key="where.id"
                                            :value="where.id">
                                            {{ where.nazwa }} - {{ where.adres_1 }}
                                        </option>
                                        <option :value="3">Inny</option>
                                    </select>

                                    <div v-if="Number(form.order_where) === 3" class="mt-2">
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            v-model="form.order_where_manual"
                                            placeholder="Wpisz adres dostawy"
                                            autocomplete="off">
                                    </div>
                                </div>
                            </div>

                            <template v-for="(article, idx) in form.articles" :key="article.id">
                                <template v-if="!article.article_id">
                                    Brak artykułu. Nie można stworzyć zamówienia.
                                </template>
                                <template v-else>
                                    <table class="table order-list-table">
                                        <tbody>
                                            <tr>
                                                <td colspan="2" class="position-relative">
                                                    <span>#{{ idx + 1 }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Do zapytania ofertowego</td>
                                                <td>{{ article.quote_request?.request_number || '' }}</td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Nr katalogowy</td>
                                                <td>{{ article.catalog_number }}</td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Model</td>
                                                <td>{{ article.model }}</td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Ilość zamawiana
                                                    <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                                                        data-bs-placement="top" data-bs-html="true"
                                                        title="Całkowita ilość. Powinna być pomniejszona o zarezerwowane sztuki."></i>
                                                </td>
                                                <td class="d-flex align-items-center">
                                                    <div v-if="hasError(`articles.${idx}.quantity_required`)"
                                                        class="text-danger small">
                                                        {{ getErrorMessage(`articles.${idx}.quantity_required`) }}
                                                    </div>
                                                    <input class="form-control form-control-sm" type="number" step="0.1"
                                                        min="0" v-model="article.quantity_required" required>
                                                    <div class="ms-2 text-nowrap">{{ form.articles[idx].unit
                                                                    }}</div>

                                                </td>
                                            </tr>
                                            <tr v-if="context !== 'from_required_project'">
                                                <td class="widthFirstTd">
                                                    Zarezerwowane <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                                                        data-bs-placement="top" data-bs-html="true"
                                                        title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                                                </td>
                                                <td
                                                    v-if="reservations[`${article.article_id}-${article.required_project_item_id}`]">
                                                    <span
                                                        v-if="reservations[`${article.article_id}-${article.required_project_item_id}`].currentlyReserved > 0"
                                                        :class="reservations[`${article.article_id}-${article.required_project_item_id}`].reservationStatus === 'zatwierdzone'
                                                            ? 'reservation-approved'
                                                            : 'reservation-notapproved'">
                                                        {{
                                                            reservations[`${article.article_id}-${article.required_project_item_id}`].currentlyReserved
                                                        }} -
                                                        {{
                                                            reservations[`${article.article_id}-${article.required_project_item_id}`].reservationStatus
                                                        }}
                                                    </span>
                                                    <span v-else>Brak rezerwacji</span>
                                                </td>

                                                <td v-else>
                                                    <span>Ładowanie...</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Ostateczny termin dostawy</td>
                                                <td>
                                                    <div v-if="hasError(`articles.${idx}.delivery_date_deadline`)"
                                                        class="text-danger small">
                                                        {{ getErrorMessage(`articles.${idx}.delivery_date_deadline`) }}
                                                    </div>
                                                    <input class="form-control form-control-sm" type="date"
                                                        v-model="article.delivery_date_deadline" required>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Producent</td>
                                                <td>
                                                    <template v-if="article.producer_short_name">
                                                        <span class="font-weight-bolder">{{ article.producer_short_name
                                                            }}</span>
                                                    </template>
                                                    <template v-else>
                                                        <i>Brak domyślnego producenta</i>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Cena netto
                                                    <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                                                        data-bs-placement="right" data-bs-html="true">
                                                    </i>
                                                </td>
                                                <td>
                                                    <input type="number" class="form-control form-control-sm" min="0"
                                                        step="0.01" v-model="article.price_netto">
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Cena brutto
                                                    <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                                                        data-bs-placement="right" data-bs-html="true">
                                                    </i>
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        class="form-control form-control-sm mt-1"
                                                        min="0"
                                                        step="0.01"
                                                        :value="calculateGrossValue(article)"
                                                        @change="updatePriceFromGross(article, $event.target.value)"
                                                        placeholder="Cena brutto">
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Rabat (%)</td>
                                                <td class="d-flex align-items-center">
                                                    <input type="number" class="form-control form-control-sm"
                                                        v-model="article.rabate">
                                                    <div class="ms-2 text-nowrap">
                                                        Kwota rabatu:
                                                        {{ Number(((article.price_netto * article.quantity_required) * (article.rabate / 100)).toFixed(2)).toLocaleString('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">VAT</td>
                                                <td>
                                                    <input type="number" class="form-control form-control-sm"
                                                        v-model="article.vat">
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Waluta</td>
                                                <td>
                                                    <select class="form-select form-select-sm"
                                                        v-model="article.currency">

                                                        <option v-for="currency in currencys" :key="currency.id"
                                                            :value="currency.name">
                                                            {{ currency.name }}
                                                        </option>

                                                    </select>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Wartość netto</td>
                                                <td>
                                                    <input type="number" class="form-control form-control-sm" disabled
                                                        min="0" step="0.01"
                                                        :value="Number(((article.price_netto * article.quantity_required) * (1 - (article.rabate / 100))).toFixed(2))">
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="widthFirstTd">Uwagi do pozycji</td>
                                                <td>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="article.comments" />
                                                </td>
                                            </tr>



                                        </tbody>
                                    </table>
                                </template>

                            </template>
                        </div>
                    </div>
                    <div class="border-top pt-3 mt-3 me-5 d-flex flex-column align-items-end">
                        <div class="fw-bold fs-6">
                            Suma przed rabatem:
                            {{ getTotalBeforeRabate().toLocaleString('pl-PL', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}) }} zł
                        </div>

                        <div class="fw-bold fs-6 text-danger">
                            Łączna kwota rabatu:
                            {{ getTotalRabate().toLocaleString('pl-PL', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}) }} zł
                        </div>

                        <div class="fw-bold fs-5">
                            Podsumowanie netto:
                            {{ getTotalNetto().toLocaleString('pl-PL', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}) }} zł
                        </div>

                        <div
                            v-if="orderHasMultipleCurrencies"
                            class="text-danger small me-3">
                            Nie można zapisać zamówienia z różnymi walutami.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            <i class="bi bi-x-square me-2"></i>Zamknij
                        </button>
                        <form @submit.prevent="editOrder">
                            <button type="submit" class="btn btn-primary"
                                :disabled="form.processing || orderHasMultipleCurrencies">
                                <i class="bi bi-save me-2"></i>
                                Zapisz zmiany
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        Modal,
        Tooltip
    } from "bootstrap";
    import {
        useForm
    } from "@inertiajs/vue3";
    import {
        DatePickerComponent
    } from "@syncfusion/ej2-vue-calendars";
    import TagSelect from "../RequiredProjectItems/TagSelect.vue";

    export default {
        components: {
            TagSelect,
            'ejs-datepicker': DatePickerComponent
        },
        props: {
            project: Number | String,
            currencys: {
                type: Array,
                default: () => []
            },
            team: String,
            order_where_list: Array,
            selectedItems: {
                type: Object,
                default: () => {}
            },
            orderComment: {
                type: String,
                default: ''
            },
            orderWhere: Number | String,
            context: String
        },

        beforeMount() {
            this.getPaymentMethods();
        },

        data() {
            return {
                errors: {},
                formKey: 0,
                isReady: false,

                globalRabate: null,
                globalCurrency: null,
                fixedNettoAmount: null,

                currency: 'PLN',
                quoteRequestNumbers: {},
                paymentMethods: [],
                modalObj: null,
                reservations: {},
                dueDateFormat: 'dd.MM.yyyy',

                form: useForm({
                    order_where: '',
                    order_where_manual: '',
                    dueDate: '',
                    payment_id: 1,
                    comment: '',
                    articles: []
                })
            };
        },

        watch: {
            selectedItems: {
                immediate: true,

                handler(newItems) {
                    this.isReady = false;

                    if (!newItems || !newItems.length) {
                        return;
                    }

                    const initialOrderWhere = Number(this.orderWhere);
                    let initialComment = String(this.orderComment ?? '');
                    let initialManualAddress = '';

                    if (initialOrderWhere === 3) {
                        const normalizedComment = initialComment
                            .replace(/\\r\\n/g, '\n')
                            .replace(/\\n/g, '\n')
                            .replace(/\r\n/g, '\n')
                            .replace(/\r/g, '\n');

                        const separatorMatch = /\n[ \t]*\n/.exec(normalizedComment);

                        if (separatorMatch) {
                            initialManualAddress = normalizedComment
                                .slice(0, separatorMatch.index)
                                .trim();

                            initialComment = normalizedComment
                                .slice(separatorMatch.index + separatorMatch[0].length)
                                .trim();
                        }
                    }
                    this.form = useForm({
                        order_where: this.orderWhere,
                        order_where_manual: initialManualAddress,
                        dueDate: this.defaultDueDate(),
                        comment: initialComment,
                        payment_id: newItems[0]?.order_payment_method_id ?? 1,
                        articles: newItems.map((article) => {
                            const quoteRequest = article.quote_request ? {
                                    id: article.quote_request.id,
                                    due_date: article.quote_request.due_date,
                                    project_id: article.quote_request.project_id,
                                    request_number: article.quote_request.request_number,
                                    team_name: article.quote_request.team_name,
                                } :
                                null;

                            return {
                                project_id: article.project_id ??
                                    article.quote_request?.project_id,

                                team_name: article.team_name ??
                                    article.quote_request?.team_name,

                                article_id: article.article_id ??
                                    article.article?.id,

                                quote_request: quoteRequest,

                                quote_request_item_id: article.quote_request_item_id ?? null,

                                quote_request_items: article.quote_request_items ?? null,

                                required_project_item_id: article.required_project_item_id ??
                                    article.required_project_items_id ??
                                    article.required_project_item?.id ??
                                    null,

                                catalog_number: article.catalog_number ??
                                    article.article?.catalog_number,

                                model: article.model ??
                                    article.article?.model,

                                order_lists_item_id: article.id,

                                quantity_required: Number(article.quantity_required) || 0,

                                delivery_date_deadline: article.delivery_date_deadline ??
                                    this.parseDueDateToInputFormat(
                                        this.defaultDueDate()
                                    ),

                                producer_short_name: article.article?.producer?.short_name ?? null,

                                producer_id: article.article?.producer_id ?? null,

                                price_netto: Number(article.price_netto) || 0,

                                rabate: article.rabate !== null &&
                                    article.rabate !== undefined &&
                                    article.rabate !== '' ?
                                    Number(article.rabate) : Number(article.article?.rabate) || 0,

                                vat: article.vat ??
                                    article.article?.vat ??
                                    23,

                                currency: article.currency ?? 'PLN',

                                comments: article.comments ?? '',

                                unit: article.article?.article_unit?.name || '',
                            };
                        }),
                    });

                    this.formKey++;
                    this.isReady = true;
                    this.syncGlobalValues();

                    this.loadReservations();

                    this.$nextTick(() => {
                        const formatted = this.parseDueDateToInputFormat(
                            this.form.dueDate
                        );

                        this.form.articles.forEach(article => {
                            if (!article.delivery_date_deadline) {
                                article.delivery_date_deadline = formatted;
                            }
                        });
                    });
                },
            },
        },
        computed: {
            orderHasMultipleCurrencies() {
                const currencies = (this.form?.articles ?? [])
                    .map(article => article.currency)
                    .filter(currency =>
                        currency !== null &&
                        currency !== undefined &&
                        currency !== ''
                    );

                return new Set(currencies).size > 1;
            }
        },
        mounted() {
            this.modalObj = new Modal(this.$refs.modalEle);
            this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
                this.$emit('clear-selection');
            });
            new Tooltip(document.body, {
                selector: "[data-bs-toggle='tooltip']",
            })
        },
        methods: {

onOrderWhereChange() {
    if (Number(this.form.order_where) === 3) {
        this.extractManualAddressFromComment();
        return;
    }

    // Dla adresów 1 i 2 usuń poprzedni adres z komentarza.
    const comment = String(this.form.comment ?? '')
        .replace(/\\r\\n/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');

    const separatorMatch = /\n[ \t]*\n/.exec(comment);

    if (separatorMatch) {
        this.form.comment = comment
            .slice(separatorMatch.index + separatorMatch[0].length)
            .trim();
    }

    this.form.order_where_manual = '';
},

extractManualAddressFromComment() {
    const comment = String(this.form.comment ?? '')
        .replace(/\\r\\n/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');

    const separatorMatch = /\n[ \t]*\n/.exec(comment);

    if (!separatorMatch) {
        return;
    }

    const address = comment
        .slice(0, separatorMatch.index)
        .trim();

    const remainingComment = comment
        .slice(separatorMatch.index + separatorMatch[0].length)
        .trim();

    if (address) {
        this.form.order_where_manual = address;
    }

    this.form.comment = remainingComment;
},
            syncGlobalValues() {
                const articles = this.form?.articles ?? [];

                if (!articles.length) {
                    this.globalRabate = null;
                    this.globalCurrency = null;
                    this.fixedNettoAmount = null;
                    return;
                }
                const discounts = articles.map(article =>
                    Number(article.rabate ?? 0)
                );

                const uniqueDiscounts = new Set(discounts);

                this.globalRabate = uniqueDiscounts.size === 1 ?
                    discounts[0] :
                    null;
                const currencies = articles.map(article =>
                    article.currency
                );

                const uniqueCurrencies = new Set(currencies);

                this.globalCurrency = uniqueCurrencies.size === 1 ?
                    currencies[0] :
                    null;
            },

            applyGlobalRabate() {
                if (
                    this.globalRabate === null ||
                    this.globalRabate === '' ||
                    !Number.isFinite(Number(this.globalRabate)) ||
                    Number(this.globalRabate) < 0
                ) {
                    return;
                }

                const discount = Number(this.globalRabate);

                this.form.articles.forEach(article => {
                    article.rabate = discount;
                });
            },

            applyGlobalCurrency() {
                if (
                    this.globalCurrency === null ||
                    this.globalCurrency === ''
                ) {
                    return;
                }

                this.form.articles.forEach(article => {
                    article.currency = this.globalCurrency;
                });
            },
            orderHasMultipleCurrencies() {
                const currencies = this.form?.articles
                    ?.map(article => article.currency)
                    .filter(currency => currency !== null && currency !== undefined && currency !== '');

                return new Set(currencies).size > 1;
            },
            updateGroupPriceFromGross(group, gross) {
                const brutto = Number(gross);
                const vat = Number(group.firstArticle.vat) || 0;

                if (!Number.isFinite(brutto) || brutto < 0 || vat <= -100) {
                    return;
                }

                const netto = Number(
                    (brutto / (1 + vat / 100)).toFixed(2)
                );

                this.updateGroupField(group, 'price_netto', netto);
            },
            applyFixedNettoAmount() {
                const target = Number(this.fixedNettoAmount);

                if (
                    this.fixedNettoAmount === null ||
                    this.fixedNettoAmount === '' ||
                    !Number.isFinite(target) ||
                    target < 0
                ) {
                    return;
                }

                const baseTotal = this.form.articles.reduce((sum, article) => {
                    const price = Number(article.price_netto) || 0;
                    const quantity = Number(article.quantity_required) || 0;

                    return sum + price * quantity;
                }, 0);

                if (baseTotal <= 0 || target > baseTotal) {
                    return;
                }

                this.globalRabate = Number(
                    ((1 - target / baseTotal) * 100).toFixed(2)
                );

                this.applyGlobalRabate();
            },

            getTotalBeforeRabate() {
                if (!Array.isArray(this.form.articles)) {
                    return 0;
                }

                const total = this.form.articles.reduce((sum, article) => {
                    const price = Number(article.price_netto) || 0;
                    const qty = Number(article.quantity_required) || 0;

                    return sum + price * qty;
                }, 0);

                return Number(total.toFixed(2));
            },

            getTotalRabate() {
                if (!Array.isArray(this.form.articles)) {
                    return 0;
                }

                const total = this.form.articles.reduce((sum, article) => {
                    const price = Number(article.price_netto) || 0;
                    const qty = Number(article.quantity_required) || 0;
                    const rabate = Number(article.rabate) || 0;

                    return sum + price * qty * (rabate / 100);
                }, 0);

                return Number(total.toFixed(2));
            },
            calculateGrossValue(article) {
                const netto = Number(article.price_netto) || 0;
                const vat = Number(article.vat) || 0;

                return Number(
                    (netto * (1 + vat / 100)).toFixed(2)
                );
            },

            updatePriceFromGross(article, gross) {
                const brutto = Number(gross);
                const vat = Number(article.vat) || 0;

                if (!Number.isFinite(brutto) || brutto < 0 || vat <= -100) {
                    return;
                }

                article.price_netto = Number(
                    (brutto / (1 + vat / 100)).toFixed(2)
                );
            },
            mergeComments(items) {
                const comments = items
                    .map(item => item.comments)
                    .filter(comment => comment && comment.trim())
                    .map(comment => comment.trim());

                return [...new Set(comments)].join(' | ');
            },

            getTotalNetto() {
                if (!Array.isArray(this.form.articles)) {
                    return 0;
                }

                const total = this.form.articles.reduce((sum, article) => {
                    const price = Number(article.price_netto) || 0;
                    const qty = Number(article.quantity_required) || 0;
                    const rabate = Number(article.rabate) || 0;

                    return sum + price * qty * (1 - rabate / 100);
                }, 0);

                return Number(total.toFixed(2));
            },

            parseDueDateToInputFormat(dateStr) {
                if (!dateStr) return null
                const [day, month, year] = dateStr.split('.')
                return `${year}-${month}-${day}`
            },

            defaultDueDate() {
                const today = new Date();
                const nextWeek = new Date(today);
                nextWeek.setDate(today.getDate() + 7);
                const year = nextWeek.getFullYear();
                const month = String(nextWeek.getMonth() + 1).padStart(2, '0');
                const day = String(nextWeek.getDate()).padStart(2, '0');

                return `${day}.${month}.${year}`;
            },

            formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            },

            changeDeliveryDate(date) {
                this.form.dueDate = date.value;

                const formatted = this.formatDate(date.value);
                this.form.articles.forEach(article => {
                    article.delivery_date_deadline = formatted;
                });
            },


            changeComment(value) {
                this.form.comment = value ?? '';
            },

            async getPaymentMethods() {
                const methods = await axios.get(route('paymentMethods.getAll'));
                this.paymentMethods = methods.data;
            },

            editOrder() {

                this.form.post(route('orderLists.editOrder'), {
                    onSuccess: () => {
                        this.$emit('added-success', 'Zmiany zostały zapisane.')
                        this.$emit('clear-selection');
                        this.hide()
                    },
                    onError: (errors) => {
                        console.log('errors:', errors)
                        this.errors = errors
                        let errorMessages = Object.values(errors).flat().join(', ')
                        this.$emit('added-error', 'Błąd podczas edycji zamówienia: ' + errorMessages)
                    }
                })
            },

            async loadReservations() {

                for (const article of this.form.articles ?? []) {

                    if (!article?.article_id || !article?.required_project_item_id) {
                        continue;
                    }


                    try {
                        const response = await axios.get(route('warehouse.check-article-reservation', {
                            article: article.article_id,
                            required_project_item_id: article.required_project_item_id,
                            reserving: 0
                        }));

                        const key = `${article.article_id}-${article.required_project_item_id}`;
                        this.reservations[key] = response.data;

                    } catch (error) {
                        console.error(error);
                    }
                }
            },

            hasError(field) {
                const error = this.errors && this.errors[field];
                return error;
            },

            getErrorMessage(field) {
                if (!this.errors[field]) {
                    return '';
                }

                if (/^Pole .*? jest wymagane\.$/.test(this.errors[field])) {
                    return 'To pole jest wymagane.';
                }

                return 'To pole ma niepoprawną wartość';
            },

            show() {
                if (this.modalObj) {
                    this.syncGlobalValues();
                    this.modalObj.show();
                }
            },
            hide() {
                if (this.modalObj) {
                    this.modalObj.hide();
                }
            },
        }
    }
</script>


<style scoped>
    .widthFirstTd {
        width: 150px;
    }

    .order-list-table:not(:first-child) {
        border-top: 2px solid #222;
    }

    .reservation-approved {
        color: #1abc9c !important;
        padding: 2px 6px;
        border-radius: 4px;
        display: inline-block;
    }

    .reservation-notapproved {
        color: #e7515a !important;
        padding: 2px 6px;
        border-radius: 4px;
        display: inline-block;
    }

    .table.order-list-table {
        font-size: 13px;
        margin-bottom: 0.75rem;
    }

    .table.order-list-table td,
    .table.order-list-table th {
        padding: 4px 6px !important;
        vertical-align: middle !important;
    }

    .table.order-list-table input.form-control-sm,
    .table.order-list-table select.form-select-sm {
        padding: 2px 6px;
        height: 28px;
        font-size: 13px;
    }

    .table.order-list-table .widthFirstTd {
        width: 140px;
        font-weight: 500;
        color: #444;
    }

    .order-list-table:not(:first-child) {
        border-top: 1px solid #bbb;
        margin-top: 6px;
        padding-top: 4px;
    }

    h6,
    .font-weight-bolder {
        font-size: 13px;
    }

    .reservation-approved,
    .reservation-notapproved {
        padding: 1px 4px;
        border-radius: 3px;
        font-size: 12px;
    }

    .btn.btn-sm.btn-outline-danger {
        padding: 2px 6px;
        font-size: 12px;
        line-height: 1;
    }
</style>